<template>
    <Modal
        v-model="showModal"
        title="WARNING"
        footer-hide
        class="delete-request-modal-wrapper"
        :closable="false"
        :mask-closable="false"
    >
        <div>
            <br />
            <p style="text-align: justify">
                Are you sure you want {{ message }} this request? This action cannot be undone.
            </p>
            <br />

            <Row class="confirmation-actions md-margin-top">
                <Col :xs="24" :sm="6">
                    <Button @click="handleConfirmation(false)"> CANCEL </Button>
                </Col>
                <Col :xs="24" :sm="6">
                    <Button class="pt-btn-3" :loading="isLoading" @click="handleConfirmation(true)"> YES </Button>
                </Col>
            </Row>
        </div>
    </Modal>
</template>

<script>
import { getRequestRecordByUserAndAttendanceId } from '@/services/requests.services';
import { timeConversion } from '../../../../../utility/helper';
import moment from 'moment/moment';
import { cancelCoe, rejectCoe } from '@/services/coe.services';

export default {
    data() {
        return {
            requestId: null,
            attendanceId: null,
            userId: null,
            message: '',
            showModal: false,
            isLoading: false,
            data: {},
        };
    },

    methods: {
        async handleGetRequestRecordByAttendanceId(data) {
            return await getRequestRecordByUserAndAttendanceId(this.attendanceId, this.userId, {
                requestedStart: timeConversion(moment.utc(data.createdAt).format('DD-MMM-YYYY'), '00:00'),
            });
        },
        async openModal(data, mensahe) {
            this.message = mensahe;
            this.showModal = true;
            this.data = data;
            this.requestId = data._id;
        },
        handleConfirmation(status) {
            this.isLoading = true;
            if (status) {
                console.log('this message: ', this.message);
                if (this.message === 'cancel') {
                    cancelCoe({ id: this.requestId })
                        .then(() => {
                            this.$Message.success(`Request Coe ${this.message} successfully`);
                            this.$emit('create');
                            this.isLoading = false;
                            this.showModal = false;
                        })
                        .catch(() => {
                            this.$Message.error(`Failed to ${this.message} request time dispute`);
                            this.isLoading = false;
                        });
                }
                if (this.message === 'reject') {
                    rejectCoe({ id: this.requestId })
                        .then(() => {
                            this.$Message.success(`Request Coe ${this.message} successfully`);
                            this.$emit('create');
                            this.isLoading = false;
                            this.showModal = false;
                        })
                        .catch(() => {
                            this.$Message.error(`Failed to ${this.message} request time dispute`);
                            this.isLoading = false;
                        });
                }
            } else {
                this.isLoading = false;
                this.showModal = false;
            }
        },
    },
};
</script>

<style>
.delete-request-modal-wrapper.v-transfer-dom .ivu-modal-body,
.ivu-modal-confirm {
    padding: 16px;
}
.delete-request-modal-wrapper .ivu-modal-header {
    background: none !important;
    border: none !important;
}
.delete-request-modal-wrapper .ivu-modal-header .ivu-modal-header-inner {
    color: brown !important;
}
.confirmation-actions {
    display: flex;
    align-content: space-between;
    justify-content: center;
}
</style>
